/**
 * UA_CLASS モジュール
 * - ブラウザ種別に応じて <body> に特定のクラス名を付与
 */
export const UA_CLASS = {
  /**
   * 初期化関数：ブラウザに応じてクラス名を <body> に追加
   */
  init() {
    const ua = navigator.userAgent.toLowerCase()
    const className = this.getBrowserClassName(ua)

    if (className) {
      document.body.classList.add(className)
    }
  },

  /**
   * ユーザーエージェントからブラウザ名に対応するクラス名を返す
   * @param {string} ua - ユーザーエージェント文字列
   * @returns {string} - ブラウザに対応したクラス名（該当しなければ空文字）
   */
  getBrowserClassName(ua) {
    if (ua.includes('msie') || ua.includes('trident')) {
      return 'browse-ie'
    }
    if (ua.includes('edg')) {
      // Microsoft Edge は新UAでは "edg"
      return 'browse-edge'
    }
    if (ua.includes('chrome')) {
      return 'browse-chrome'
    }
    if (ua.includes('safari') && !ua.includes('chrome')) {
      return 'browse-safari'
    }
    if (ua.includes('firefox')) {
      return 'browse-firefox'
    }
    if (ua.includes('opera') || ua.includes('opr')) {
      return 'browse-opera'
    }
    return ''
  },
}
